import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (!window.$ || !window.$.fn || !window.$.fn.popover) return

    window.$(this.element).popover({
      container: "body",
      html: true,
      trigger: this.element.dataset.trigger || "focus",
      placement: this.element.dataset.placement || "left",
      boundary: "viewport"
    })
  }

  disconnect() {
    if (!window.$ || !window.$.fn || !window.$.fn.popover) return
    try { window.$(this.element).popover("dispose") } catch (e) {}
  }
}